import React, { FC } from "react";
import {Banner} from "@jobber/components/Banner";

type ErrorBannerProps = {
    message: string,
};

const ErrorBanner: FC<ErrorBannerProps> = ({
    message,
}) => {
    return (
        <Banner
            type={"error"}
            icon={"alert"}
            primaryAction={{
                label: "Try Again",
                onClick: () => window.location.reload(),
            }}
        >
            {message}
        </Banner>
    );
};

export default ErrorBanner;